import { useState, useEffect } from "react";
import { AppApi } from "../../api";
import { useNavigate, useParams } from "react-router-dom";
import { s3File } from "../../utils/fileFormater";
import { CardProduct } from "../../components/Card/Cardmain";
import useSweetAlert from "../../_hooks/useSweetAlert";
import {
  CONCRETE_PILES_ID,
  OTHER_SANITARY_EQUIPMENT_ID,
  OTHER_DOOR_AND_FRAMEDOOR_ID,
} from "../../utils/constants";
import { Dialog, DialogHeader, DialogBody } from "@material-tailwind/react";

const SubCategoryLevel3View = () => {
  const { categoryPath, subCategoryPath } = useParams();

  const navigate = useNavigate();

  const [open, setOpen] = useState(false);
  const [deleteData, setDeleteData] = useState(null);

  const reloadCategory = async () => {
    const parentCategoryId = deleteData?.parent_category_id;
    try {
      const { data } = await AppApi.get(
        `categorys?parent_category_id=${parentCategoryId}&category_level=3`
      );
      setCategorys(data.categorys);
    } catch (error) {
      console.log(error);
    }
  };

  const [title, setTitle] = useState("");
  const [image, setImage] = useState(null);
  const [parentCategoryTitle, setParentCategoryTitle] = useState("");

  const [categoryId, setCategoryId] = useState("");
  const [categoryL2Id, setCategoryL2Id] = useState("");

  // Check Category Level 2 ID
  const isConcretePiles = categoryL2Id === CONCRETE_PILES_ID;
  const isOtherSanitaryEquipment = categoryL2Id === OTHER_SANITARY_EQUIPMENT_ID;
  const isOtherDoorAndFrameDoor = categoryL2Id === OTHER_DOOR_AND_FRAMEDOOR_ID;

  const [categorys, setCategorys] = useState([]);
  // console.log("categorys : ", categorys);

  const { alertConfirm, alertSuccess, alertError } = useSweetAlert();

  const handleOpen = () => setOpen(!open);

  useEffect(() => {
    let ignore = false;
    if (!ignore) {
      const load = async () => {
        try {
          const { data } = await AppApi.get(`categorys/${subCategoryPath}`);
          const category = data.category;
          const parentSubCategoryId = category._id;

          const { data: dataSubCategorys } = await AppApi.get(
            `categorys?parent_category_id=${parentSubCategoryId}&category_level=3`
          );
          setCategorys(dataSubCategorys.categorys);

          setCategoryL2Id(category._id);
          setTitle(category.category_name);
          setImage(s3File(category.image_key));
        } catch (error) {
          console.log(error);
        }
      };
      load();
    }
    return () => {
      ignore = true;
    };
  }, [subCategoryPath]);

  useEffect(() => {
    let ignore = false;
    if (!ignore) {
      const load = async () => {
        try {
          const { data } = await AppApi.get(`categorys/${categoryPath}`);
          const category = data.category;

          setCategoryId(category._id);
          setParentCategoryTitle(category.category_name);
        } catch (error) {
          console.log(error);
        }
      };
      load();
    }
    return () => {
      ignore = true;
    };
  }, [categoryPath]);

  const onClickCategory = (categoryPath, path, categoryL2Id) => {
    navigate(
      `/category/${categoryPath}/${path}?view?categoryL2Id_${categoryL2Id}`
    );
  };

  const clickEditCategory = (id) => {
    navigate(`/category/${categoryPath}/${subCategoryPath}/categoryL3/${id}`);
  };

  const clickDeleteCategory = (data) => {
    setOpen(true);
    setDeleteData(data);
  };

  const confirmDelete = async () => {
    const categoryId = deleteData?._id;
    const totalProduct = deleteData?.totalProduct;

    try {
      if (totalProduct === 0) {
        await AppApi.delete(`categorys/${categoryId}`);
        setOpen(false);
        reloadCategory();
        alertSuccess("Delete Success");
      } else {
        setOpen(false);
        alertError(`ลบสินค้าข้างใน ${totalProduct} รายการออกก่อน`);
      }
    } catch (error) {
      console.log("ERROR TO DELETE CATEGORY", error);
    }
  };

  return (
    <div className="flex flex-col gap-5">
      <div className="flex justify-between">
        <div className="flex items-center gap-4">
          <img src={image} className="w-24 h-24 bg-white rounded-xl" />
          <div className="flex flex-col">
            <div className="text-white sm:text-[24px] md:text-[32px] lg:text-[48px]">
              {title}
            </div>
            <div className="text-gray-500 bg-white border-2 rounded-full text-center w-48">
              {parentCategoryTitle}
            </div>
          </div>
        </div>
        <div className="flex flex-col justify-end text-[28px] text-white font-bold">
          จำนวนสินค้า {categorys.length}
        </div>
      </div>

      <div className="flex flex-col gap-12 bg-white p-8 rounded-2xl drop-shadow-xl">
        {categorys.length === 0 ? (
          <div className="flex justify-center items-center">
            <img src="/not-found.png" className=" w-60 h-60" />
          </div>
        ) : isConcretePiles ? (
          <div className="flex justify-center items-center">
            <div className="grid grid-cols-4 gap-5">
              {categorys
                ?.sort((a, b) => a.number_index - b.number_index)
                ?.map((category, index) => {
                  const imageSrc = s3File(category.image_key);
                  return (
                    <CardProduct
                      key={index}
                      isCategory={true}
                      categoryId={categoryId}
                      totalProduct={category.totalProduct}
                      name={category.category_name}
                      img={imageSrc}
                      list={category.number_index}
                      onClick={() =>
                        onClickCategory(
                          categoryPath,
                          category.path,
                          categoryL2Id
                        )
                      }
                      onClickEdit={() => clickEditCategory(category._id)}
                      // onClickDelete={() => clickDeleteCategory(category._id)}
                    />
                  );
                })}
            </div>
          </div>
        ) : (
          <div className="flex justify-center items-center">
            <div className="grid grid-cols-4 gap-5">
              {categorys
                ?.sort((a, b) => a.number_index - b.number_index)
                ?.map((category, index) => {
                  const imageSrc = s3File(category.image_key);
                  return (
                    <CardProduct
                      key={index}
                      isCategory={true}
                      isOtherSanitaryEquipment={isOtherSanitaryEquipment}
                      isOtherDoorAndFrameDoor={isOtherDoorAndFrameDoor}
                      // categoryId={categoryId}
                      subCategoryId={category._id}
                      totalProduct={category.totalProduct}
                      totalSubCategory={category?.totalSubCategory}
                      name={category.category_name}
                      img={imageSrc}
                      list={category.number_index}
                      onClick={() =>
                        onClickCategory(
                          categoryPath,
                          category.path,
                          categoryL2Id
                        )
                      }
                      onClickEdit={() => clickEditCategory(category._id)}
                      onClickDelete={() => clickDeleteCategory(category)}
                    />
                  );
                })}
            </div>
          </div>
        )}

        {isConcretePiles ||
        isOtherSanitaryEquipment ||
        isOtherDoorAndFrameDoor ? (
          ""
        ) : (
          <div className="flex flex-col items-center gap-2">
            <button
              className="flex justify-center items-center text-white bg-primary rounded-full p-2 w-full"
              onClick={() => {
                navigate(
                  `/category/${categoryPath}/${subCategoryPath}/categoryL3/add`
                );
              }}
            >
              <svg
                width="33"
                height="32"
                viewBox="0 0 33 32"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g filter="url(#filter0_d_2949_632)">
                  <g clip-path="url(#clip0_2949_632)">
                    <path
                      d="M12.5 16H9.93C7.64 16 6.5 14.86 6.5 12.57V5.43C6.5 3.14 7.64 2 9.93 2H14.5C16.79 2 17.93 3.14 17.93 5.43"
                      stroke="white"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M23.0699 22H18.4999C16.2099 22 15.0699 20.86 15.0699 18.57V11.43C15.0699 9.14 16.2099 8 18.4999 8H23.0699C25.3599 8 26.4999 9.14 26.4999 11.43V18.57C26.4999 20.86 25.3599 22 23.0699 22Z"
                      stroke="white"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M19.37 15H22.63"
                      stroke="white"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M21 16.6301V13.3701"
                      stroke="white"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </g>
                </g>
                <defs>
                  <filter
                    id="filter0_d_2949_632"
                    x="0.5"
                    y="0"
                    width="32"
                    height="32"
                    filterUnits="userSpaceOnUse"
                    color-interpolation-filters="sRGB"
                  >
                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                    <feColorMatrix
                      in="SourceAlpha"
                      type="matrix"
                      values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                      result="hardAlpha"
                    />
                    <feOffset dy="4" />
                    <feGaussianBlur stdDeviation="2" />
                    <feComposite in2="hardAlpha" operator="out" />
                    <feColorMatrix
                      type="matrix"
                      values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
                    />
                    <feBlend
                      mode="normal"
                      in2="BackgroundImageFix"
                      result="effect1_dropShadow_2949_632"
                    />
                    <feBlend
                      mode="normal"
                      in="SourceGraphic"
                      in2="effect1_dropShadow_2949_632"
                      result="shape"
                    />
                  </filter>
                  <clipPath id="clip0_2949_632">
                    <rect
                      width="24"
                      height="24"
                      fill="white"
                      transform="translate(4.5)"
                    />
                  </clipPath>
                </defs>
              </svg>
              <div>เพิ่มประเภท</div>
            </button>
            <div className="text-gray-400">(สามารถเพิ่มประเภทเองได้)</div>
          </div>
        )}
      </div>

      <Dialog
        size="sm"
        open={open}
        handler={handleOpen}
        className="p-[20px] rounded-[20px] relative"
      >
        <svg
          width="30"
          height="30"
          viewBox="0 0 30 30"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className=" absolute right-[20px] cursor-pointer"
          onClick={handleOpen}
        >
          <path
            d="M15 27.5C21.875 27.5 27.5 21.875 27.5 15C27.5 8.125 21.875 2.5 15 2.5C8.125 2.5 2.5 8.125 2.5 15C2.5 21.875 8.125 27.5 15 27.5Z"
            stroke="#4A4A4A"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M11.4624 18.5375L18.5374 11.4625"
            stroke="#4A4A4A"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M18.5374 18.5375L11.4624 11.4625"
            stroke="#4A4A4A"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
        <DialogHeader className="text-primary_red text-[36px] flex flex-col items-center">
          <svg
            width="81"
            height="80"
            viewBox="0 0 81 80"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            xlink="http://www.w3.org/1999/xlink"
          >
            <rect x="0.5" width="80" height="79.1579" fill="url(#pattern0)" />
            <defs>
              <pattern
                id="pattern0"
                patternContentUnits="objectBoundingBox"
                width="1"
                height="1"
              >
                <use
                  href="#image0_3750_188884"
                  transform="matrix(0.002 0 0 0.00202128 0 -0.00531918)"
                />
              </pattern>
              <image
                id="image0_3750_188884"
                width="500"
                height="500"
                href="data:image/png;base64,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"
              />
            </defs>
          </svg>
          <span>ยืนยันลบสินค้า</span>
        </DialogHeader>
        <DialogBody className="bg-[#f8f8f8] rounded-[10px] pt-[20px] pb-[20px] text-[16px] text-primary_gray flex justify-center gap-2">
          <span>คุณต้องการลบ</span>
          <span className="text-primary_red">
            "{deleteData?.category_name}"
          </span>
          <span>ใช่หรือไม่</span>
        </DialogBody>
        <div className="flex justify-center mt-[20px] gap-[10px]">
          <button
            onClick={handleOpen}
            className="bg-white border-2 border-primary_gray rounded-full w-full h-[45px] text-primary_gray text-[16px]"
          >
            <span>ยกเลิก</span>
          </button>
          <button
            onClick={confirmDelete}
            className="bg-primary_red border-2 border-primary_red rounded-full w-full h-[45px] text-white text-[16px] hover:text-primary_red hover:bg-white duration-300"
          >
            <span>ลบสินค้า</span>
          </button>
        </div>
      </Dialog>
    </div>
  );
};

export default SubCategoryLevel3View;
